<template>
  <div>
    <v-card width="100%" height="300" outlined>
      <v-hover v-slot:default="{ hover }" v-if="localImage">
        <v-img :src="localImage" height="300" @click="showLocal">
          <v-fade-transition>
            <div v-if="hover" class="d-flex flex-row-reverse align-end" style="height: 100%;">
              <v-btn text icon color="red" x-large @click.stop="deleteAll">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
              <v-btn text icon color="primary" x-large @click.stop="$refs.fileupload.click()">
                <v-icon>mdi-file-upload</v-icon>
              </v-btn>
            </div>
          </v-fade-transition>
        </v-img>
      </v-hover>

      <v-hover v-slot:default="{ hover }" v-else-if="reportPhotoUrl">
        <v-img :src="`${$config.apiUrl}/${reportPhotoUrl}`" height="300" @click="showUrl">
          <v-fade-transition>
            <div v-if="hover" class="d-flex flex-row-reverse align-end" style="height: 100%;">
              <v-btn text icon color="red" x-large @click.stop="deleteAll">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
              <v-btn text icon color="primary" x-large @click.stop="$refs.fileupload.click()">
                <v-icon>mdi-file-upload</v-icon>
              </v-btn>
            </div>
          </v-fade-transition>
        </v-img>
      </v-hover>
      <div
        @click="$refs.fileupload.click()"
        v-ripple
        class="d-flex justify-center"
        style="width:100%;height:100%"
        v-else
      >
        <v-icon x-large>mdi-plus</v-icon>
      </div>
      <input
        v-show="false"
        type="file"
        ref="fileupload"
        @change="showPreviou"
        accept=".jpg, .jpeg, .png"
      />
    </v-card>
    <v-dialog v-model="dialog" :max-width="dialogWidth">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
          <v-img contain :src="dialogImage"></v-img>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialog = false">關閉</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  props: ["photoIndex"],
  data() {
    return {
      product: {},
      productCode: "",
      reportPhotoUrl: "",
      photoUrlWidth: 0,
      photoUrlHeight: 0,
      account: "",
      localImage: "",
      localPhoto: "",
      localImageWidth: 0,
      localImageHeight: 0,
      dialog: false,
      dialogWidth: 0,
      dialogImage: ""
    };
  },
  methods: {
    async init() {},
    showPreviou(event) {
      const photo = event.target.files.item(0);
      if (photo) {
        const reader = new FileReader();
        reader.addEventListener("load", this.imageLoader);
        reader.readAsDataURL(photo);
        this.localPhoto = photo;
        //this.uploadRecordPhoto(photo);
      }
    },
    imageLoader(event) {
      this.localImage = event.target.result;
      let thisVm = this;
      let image = new Image();
      image.src = event.target.result;
      image.onload = function() {
        // access image size here
        thisVm.localImageWidth = this.width;
        thisVm.localImageHeight = this.height;

        //clear report image url
        thisVm.reportPhotoUrl = null;
      };
    },
    showLocal() {
      this.dialogWidth = Math.min(
        this.localImageWidth,
        (this.$vuetify.breakpoint.width * 2) / 3
      );
      this.dialogImage = this.localImage;
      this.dialog = true;
    },
    showUrl() {
      this.dialogWidth = Math.min(
        this.photoUrlWidth,
        (this.$vuetify.breakpoint.width * 2) / 3
      );
      this.dialogImage = `${this.$config.apiUrl}/${this.reportPhotoUrl}`;
      this.dialog = true;
    },
    // async uploadRecordPhoto(photo) {
    //   this.$emit("upload", this.photoIndex, photo);
    // },
    getLoaclPhoto() {
      return this.localPhoto;
    },
    getPhotoUrl() {
      return this.reportPhotoUrl;
    },
    setPhotoUrl(photoUrl) {
      this.deleteAll();
      this.reportPhotoUrl = photoUrl;
      let thisVm = this;
      let img = new Image();
      img.onload = function() {
        thisVm.photoUrlWidth = this.width;
        thisVm.photoUrlHeight = this.height;
      };
      img.src = `${this.$config.apiUrl}/${photoUrl}`;
    },
    deleteAll() {
      this.reportPhotoUrl = null;
      this.localImage = null;
      this.localPhoto = null;
    }
  },

  created() {
    console.log("window width:" + this.$vuetify.breakpoint.width);
  }
};
</script>
